module.exports = __webpack_public_path__ + "img/shield-slash-fill.2b6b7a26.svg";